<template>
  <div class="container p-16">
    <div class="d-flex justify-content-between">
      <span class="add-plans" @click="showAddAvaiability"
        >+ ADD AVAILABILITY</span
      >
    </div>
    <scheduler
      class="left-container"
      :events="availableTimes"
      @event-updated="logEventUpdate"
    ></scheduler>
    <div class="right-container">
      <ul class="scheduler-messages">
        <li
          class="scheduler-message"
          v-for="message in messages"
          :key="message + 1"
        >
          {{ message }}
        </li>
      </ul>
    </div>
    <modal :id="scheduleModal">
      <div class="add-plan">
        <span class="close-icon" @click="$bvModal.hide(scheduleModal)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>

        <h3>Add Availability</h3>
        <div class="h-18"></div>
        <b-form-group label="Title">
          <b-form-input
            type="text"
            required
            v-model="newAvailability.title"
            placeholder="Enter your availibility title here"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Date time ">
          <span class="pre"
            ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 10C2 9.44771 2.44772 9 3 9H21C21.5523 9 22 9.44771 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          <b-form-input
            @click="$bvModal.show('calendar-modal')"
            @keydown="$bvModal.show('calendar-modal')"
            v-model="newAvailability.datetime"
            placeholder="dd/mm/yyyy   00:00 AM"
            type="datetime"
            required
            class="pl-5 black-placeholder"
          ></b-form-input>
        </b-form-group>
        <!-- placeholder="Enter your sessions title here" -->
        <div class="digtim">
          <label>Slot with duration</label>

          <!-- <b-form-group label=""> -->
          <!-- <b-form-input type="number" required></b-form-input> -->
          <select
            class="form-control select-custom"
            v-model="newAvailability.duration"
          >
            <option value="15" selected>15</option>
            <option value="30">30</option>
            <option value="45">45</option>
          </select>
          <!-- </b-form-group> -->
          <label>Minutes</label>
        </div>

        <div class="foot">
          <div class="d-flex justify-content-between">
            <b-button class="btn-simple" @click="$bvModal.hide(scheduleModal)">
              Cancel
            </b-button>
            <b-button variant="primary btn-round-fill" @click="addAvailablity">
              Add
            </b-button>
          </div>
        </div>
      </div>
    </modal>
    <Calendar @updateDate="updateDateTime" />
  </div>
</template>

<script>
import moment from "moment";
import Scheduler from "@/components/scheduler";
import Modal from "@/components/common/modal";
import Calendar from "@/components/common/calendar";
// import Scheduler from "../../../../../components/scheduler";
// import Modal from "../../../../../components/common/modal";
// import Calendar from "../../../../../components/common/calendar";
export default {
  name: "ScheduleCalendar",
  components: { Scheduler, Modal, Calendar },
  data() {
    return {
      scheduleModal: "schedule-modal",
      availableTimes: [],
      events: [
        {
          id: 1,
          start_date: "2020-09-21 6:00",
          end_date: "2020-09-21 8:00",
          text: "Event 1"
        },
        {
          id: 2,
          start_date: "2020-09-23 6:00",
          end_date: "2020-09-23 12:00",
          text: "Event 2"
        },
        {
          id: 3,
          start_date: "2020-09-24 9:00",
          end_date: "2020-09-24 14:00",
          text: "Open Time"
        }
      ],
      newAvailability: {
        title: "",
        datetime: "",
        duration: "15"
      },
      messages: []
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  beforeMount() {
    this.fetching = true;
  },
  mounted() {
    this.getAvailability();
  },
  methods: {
    getAvailability() {
      this.$store
        .dispatch("listings/getGuideAvailability", this.profile.userId)
        .then(res => {
          console.log("jjjj =>", res);
          if (res) {
            let slots = res;
            let allData = [];
            for (var prop in slots) {
              console.log("prop new", prop, slots[prop]);
              // for (var day in this.slots[prop]) {
              //   console.log("dayslot", this.slots[prop][day]);
              if (slots && prop !== "timings" && prop !== "_created_at") {
                // slots[prop].forEach(async element => {
                //   console.log(prop);
                //   let today = new Date();
                //   // let todaye = new Date();
                //   let timeSlot = {};
                //   timeSlot.text = prop + " time slot";
                //   let slotTime = await this.revertStart(
                //     element.start,
                //     element.end,
                //     prop
                //   );
                //   timeSlot.start_date = new Date(
                //     today.getFullYear(),
                //     today.getMonth(),
                //     today.getDate(),
                //     slotTime.startTime.hour,
                //     slotTime.startTime.mins
                //   );
                //   timeSlot.end_date = new Date(
                //     "9999",
                //     today.getMonth(),
                //     today.getDate(),
                //   );
                //   timeSlot._start_date = null
                //   timeSlot._end_date = new Date(
                //     "9999",
                //     today.getMonth(),
                //     today.getDate(),
                //   );
                //   timeSlot.rec_type = "week_1___"+slotTime.day;
                //   timeSlot.rec_pattern = "week_1___"+slotTime.day+"#no";
                //   timeSlot.event_length = 2700;
                //   timeSlot.details= " Tampa Bay, FL "
                //   allData.push(timeSlot);
                // });
              } else if (slots && prop == "timings" && prop !== "_created_at") {
                slots.timings.forEach(element => {
                  console.log("available times", element);
                  element.start_date = element.start_date.toDate();
                  element.end_date = element.end_date.toDate();
                  allData.push(element);
                });
              }
            }
            this.availableTimes = allData;
          }
          this.fetching = false;
        })
        .catch(e => {
          console.log("Error in Fetching Guide Availability.", e);
        });
    },
    revertStart(start_time, end_time, prop) {
      let s_slot = {};
      let e_slot = {};
      let s_hour = start_time.slice(0, 2);
      let s_mins = start_time.slice(2, 4);
      s_slot.period = this.getPeriod(s_hour);
      // s_slot.hour = s_slot.period == "PM" ? s_hour - 12 : s_hour;
      s_slot.hour = s_hour == 0 ? "12" : s_hour;
      s_slot.mins = s_mins;
      let e_hour = end_time.slice(0, 2);
      let e_mins = end_time.slice(2, 4);
      e_slot.period = this.getPeriod(e_hour);
      // e_slot.hour = e_slot.period == "PM" ? e_hour - 12 : e_hour;
      e_slot.hour = e_hour == 0 ? "12" : e_hour;
      e_slot.mins = e_mins;
      // return { startTime: this.slot };
      let day = this.getDay(prop);
      console.log("this.slot", {
        startTime: s_slot,
        endTime: e_slot,
        day: day
      });
      let slot = { startTime: s_slot, endTime: e_slot, day };
      return slot;
      // this.slots[prop].slots.push({ startTime: s_slot, endTime: e_slot });
    },
    getDay(prop) {
      switch (prop) {
        case "mon":
          return "1";
          break;
        case "tue":
          return "2";
          break;
        case "wed":
          return "3";
          break;
        case "thu":
          return "4";
          break;
        case "fri":
          return "5";
          break;
        case "sat":
          return "6";
          break;
        case "sun":
          return "7";
          break;
      }
    },
    getPeriod(hour) {
      return parseInt(hour) < 13 ? "AM" : "PM";
    },
    saveAvailablity(id, mode, event) {
      if (event.start_date < new Date()) {
        this.$store.dispatch("user/showNotification", {
          title: "Cannot Add Availbility",
          description: "You cannot add availability in past.",
          variant: "warning"
        });
        this.availableTimes = [];
        this.logEventUpdate(id, "deleted");
      } else {
        console.log("tag", "inin");
        this.$store
          .dispatch("listings/updateGuideAvailability", {
            id: id,
            mode: mode,
            time: event,
            guideId: this.profile.userId
          })
          .then(() => {
            this.getAvailability();
            this.$store.dispatch("user/showNotification", {
              title: "Success",
              description: "Availbility updated successfully.",
              variant: "success"
            });
          })
          .catch(e => {
            this.$store.dispatch("user/showNotification", {
              title: "Error Updating Guide Availability",
              description: e,
              variant: "danger"
            });
          });
      }
    },
    updateDateTime(dateTime) {
      this.newAvailability.datetime =
        dateTime.date.format + " " + dateTime.time.split(" ")[0];
      console.log(this.newAvailability.datetime);
      this.$bvModal.hide("calendar-modal");
    },
    addMessage(message) {
      this.messages.unshift(message);
      if (this.messages.length > 40) {
        this.messages.pop();
      }
    },
    addAvailablity() {
      console.log(this.newAvailability.datetime);
      let id = this.availableTimes.length + 1;
      let startDate = moment(
        this.newAvailability.datetime,
        "DD-MM-YYYY hh:mm AA"
      ).toDate();
      console.log("startDate", startDate);
      // let startDate = this.newAvailability.datetime.split(" ")[0];
      let endDate = new Date(startDate);
      endDate.setMinutes(
        startDate.getMinutes() + this.newAvailability.duration
      );
      console.log("endDate", endDate);
      // let startTime = this.newAvailability.datetime.split(" ")[1];
      // let startHour = startTime.split(":")[0];
      // let startMins = startTime.split(":")[1];
      // let endMins =
      //   parseInt(startMins) + parseInt(this.newAvailability.duration);
      // while (parseInt(startMins) > 59) {
      //   startMins = parseInt(startMins) - 60;
      //   startHour = parseInt(startHour) + 1;
      // }
      let event = {
        id: id,
        start_date: startDate,
        end_date: endDate,
        text: this.newAvailability.title
      };
      // this.events.push({
      //   // id: this.events.length + 1,
      //   start_date: this.newAvailability.datetime,
      //   end_date: startTime + " " + startHour + ":" + endMins,
      //   text: this.newAvailability.title
      // });

      this.saveAvailablity(id, "inserted", event);
      this.$bvModal.hide(this.scheduleModal);
    },

    logEventUpdate(id, mode, ev) {
      this.saveAvailablity(id, mode, ev);
      // let text = ev && ev.text ? ` (${ev.text})` : "";
      // let message = `Event ${mode}: ${id} ${text}`;
      // this.addMessage(message);
    },
    showAddAvaiability() {
      this.$bvModal.show(this.scheduleModal);
    }
  }
};
</script>

<style lang="scss">
.select-custom {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url("data:image/svg+xml;utf8,<svg fill='lightgrey' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 82%;
  background-position-y: 50%;
  padding: 4px 24px !important;
}
.p-16 {
  padding: 16px;
}
.add-plans {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #557efb;
  cursor: pointer;
  position: relative;
}
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.container {
  height: 100%;
  width: 100%;
}

.left-container {
  overflow: hidden;
  position: relative;
  height: 600px;
  display: inline-block;
  width: 100%;
}

.right-container {
  display: none;
  border-right: 1px solid #cecece;
  float: right;
  height: 100%;
  width: 340px;
  box-shadow: 0 0 5px 2px #aaa;
  position: relative;
  z-index: 2;
}

.scheduler-messages {
  list-style-type: none;
  height: 50%;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-left: 5px;
}

.scheduler-messages > .scheduler-message {
  background-color: #f4f4f4;
  box-shadow: inset 5px 0 #d69000;
  font-family: Geneva, Arial, Helvetica, sans-serif;
  font-size: 14px;
  margin: 5px 0;
  padding: 8px 0 8px 10px;
}

.add-plan {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    // margin-top: 48px;
    // margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}

.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.digtim {
  display: flex;
  align-items: center;
  margin-top: 15px;
  label {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8d99a0;
  }
  select {
    // background: #ffffff;
    /* text-field */
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 40px;
    height: 47px;
    width: 97px;
    margin: 0 24px;
  }
}
</style>
